import { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Leichtgewichtiges Akkordeon ohne Höhenmessung (Radix misst jedes zugeklappte Element per getBoundingClientRect → erzwungene Layouts, teuer auf Handys).
 *  Öffnen/Schließen per CSS-Grid-Übergang (0fr → 1fr); Inhalt bleibt im DOM (SEO), zugeklappt unsichtbar und nicht fokussierbar. */
export const SimpleAccordion = ({ items, className = "", testId = "accordion", titleClass = "text-base font-semibold text-stone-900", contentClass = "text-stone-700 leading-relaxed whitespace-pre-line" }) => {
  const [open, setOpen] = useState(null);
  return (
    <div className={className}>
      {items.map((it, i) => {
        const on = open === i;
        const id = `${testId}-${i}`;
        return (
          <div key={it.key ?? i} className="border-b" data-state={on ? "open" : "closed"} data-testid={`${testId}-item-${i}`}>
            <h3 className="flex">
              <button type="button" id={`${id}-trigger`} aria-expanded={on} aria-controls={`${id}-panel`} onClick={() => setOpen(on ? null : i)}
                      className={`flex flex-1 items-center justify-between gap-4 py-4 text-left hover:underline ${titleClass}`} data-testid={`${testId}-trigger-${i}`}>
                {it.title}
                <ChevronDown className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200 ${on ? "rotate-180" : ""}`} />
              </button>
            </h3>
            <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-trigger`} className="grid transition-[grid-template-rows] duration-200 ease-out" style={{ gridTemplateRows: on ? "1fr" : "0fr" }}>
              <div className={`overflow-hidden ${on ? "" : "invisible"}`}><div className={`pb-4 text-sm ${contentClass}`}>{it.content}</div></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
